import { GiCrownCoin } from 'react-icons/gi'
import SectionsHead from './SectionsHead'
import Card from '../UI/Card'
import { Link } from 'react-router-dom'
import { BiCaretRightCircle } from 'react-icons/bi'
import { useEffect, useState } from 'react';
import { SiOpenaigym } from 'react-icons/si'
import { CircularProgress } from '@mui/material'

import axiosInstance from '../utils/axiosInstance'


const Programs = () => {
    const [programs, setPrograms] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getPlans = async () => {
            setLoading(true);
          
            await axiosInstance.get(`plans/all`).then((response) => {
                setLoading(false);
                setPrograms(response.data.data);
            }).catch((error) => {
                setLoading(false);
                if(error.response && error.response.data.message === "No plans found") {
                    setPrograms([]);
                } else if(error.response && error.response.data.message !== "No plans found") {
                    setPrograms([]);
                } else {
                    setPrograms([]);
                }
            });
        }

        getPlans();
    }, [])

    return (
        <section className="programs_container">
            <div className='container programs_container'>
                <SectionsHead icon={<GiCrownCoin />} title="Our Programs" />
                {loading ?
                    <div className="flex justify-center items-center pt-20"><CircularProgress /></div>
                :
                    <div className="programs_wrapper">
                        {programs.length > 0 ?
                            programs.map(({ id, title, price }) => {
                                return (
                                    <Card className="programes_programe" key={id}>
                                        <span><SiOpenaigym /></span>
                                        <h4>{title}</h4>
                                        <small>{price}</small>
                                        <Link to="/plans" className='btn sm'>Learn More <BiCaretRightCircle /></Link>
                                    </Card>
                                )
                            })
                        :
                            <div className="w-full text-red-500 font-bold text-center text-xl">Plans not created yet</div>
                        }
                    </div>
                }
            </div>
        </section>
    )
}

export default Programs